<script setup lang="ts">
import { useTranslation } from '@/plugins/i18n/useTranslation';
import BaseTooltip from './BaseTooltip.vue';
import { onMounted, useTemplateRef } from 'vue';

export type BaseIconProps = {
  icon: string;
  color?: string;
  size?: number;
  dataCy?: string;
  title?: string;
};

const { t } = useTranslation();

const props = defineProps<BaseIconProps>();
const iconRef = useTemplateRef('icon');

onMounted(() => {
  if (iconRef.value && props.dataCy) {
    iconRef.value?.$el?.setAttribute('data-cy', props.dataCy);
  }
});
</script>
<template>
  <span v-if="props.title">
    <v-icon
      v-if="props.icon"
      ref="icon"
      :class="props.icon"
      :icon="props.icon"
      :color="props.color || ''"
      :size="props.size || 24"
      :data-cy="props.dataCy"
      :title="t(props.title || '')"
    />
    <BaseTooltip v-if="props.title">
      {{ t(props.title || '') }}
    </BaseTooltip>
  </span>
  <v-icon
    v-else
    ref="icon"
    :class="props.icon"
    :icon="props.icon"
    :color="props.color || ''"
    :size="props.size || 24"
    :data-cy="props.dataCy"
    :title="t(props.title || '')"
  />
</template>
